import { combineReducers } from 'redux';
import loginReducer from '../routes/Login/reducer';
import signupReducer from '../routes/SignUp/reducer';
import loginLayoutReducer from '../layouts/LoggedIn/reducer';
import roomReducer from '../routes/Room/reducer';
import contactsReducer from '../routes/Contacts/reducer';
import settingsReducer from '../routes/Settings/reducer';
import mangePlansReducer from '../routes/ManagePlans/reducer';
import resetReducer from '../routes/ResetPassword/reducer';
import registrationReducer from '../routes/Registration/reducer';
import planReducer from '../components/PlanDetails/reducer'

// we used combineReducers() to combine several reducers into one
const reducer = combineReducers({
  login: loginReducer,
  signup: signupReducer,
  loginLayout: loginLayoutReducer,
  rooms: roomReducer,
  contacts: contactsReducer,
  settings: settingsReducer,
  managePlans: mangePlansReducer,
  reset: resetReducer,
  registration: registrationReducer,
  planDetails: planReducer
});

export default reducer;



// WEBPACK FOOTER //
// ./src/config/reducer.js